import type {
  ClaimOfferRequest,
  FetchAdsRequest,
  TrackEventsRequest,
} from "@b2bportal/media-ads-api";
import { mediaAdsApi } from "@b2bportal/media-ads-api";
import type { AxiosInstance, RawAxiosRequestConfig } from "axios";

/**
 * Late-bound reference to the shared axios instance.
 * Set via `setMediaAxiosInstance` during app bootstrap so
 * core-media never imports directly from `@hopper-b2b/api`,
 * avoiding an NX module-boundary violation.
 */
let _axiosInstance: AxiosInstance | null = null;

export function setMediaAxiosInstance(instance: AxiosInstance): void {
  _axiosInstance = instance;
}

function getAxiosInstance(): AxiosInstance {
  if (!_axiosInstance) {
    throw new Error(
      "core-media: axiosInstance not set. Call setMediaAxiosInstance() during app bootstrap."
    );
  }
  return _axiosInstance;
}

const api = () => mediaAdsApi(getAxiosInstance());

/**
 * Fetches display ads for a given placement.
 * Standalone function that does not depend on React.
 */
export const fetchDisplayAds = (
  request: FetchAdsRequest,
  options?: RawAxiosRequestConfig
) => api().apiV1MediaAdsDisplayAdsPost(request, options);

/**
 * Tracks ad events (impressions, clicks, etc.).
 * Standalone function that does not depend on React.
 */
export const trackAdEvents = (
  request: TrackEventsRequest,
  options?: RawAxiosRequestConfig
) => api().apiV1MediaAdsEventsPost(request, options);

/**
 * Claims an offer for the current user.
 * Standalone function that does not depend on React.
 */
export const claimMediaOffer = (
  request: ClaimOfferRequest,
  options?: RawAxiosRequestConfig
) => api().apiV1MediaAdsOffersClaimPost(request, options);
